import { Link } from "react-router-dom";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useTranslation } from "react-i18next";

const InboxEmptyState = ({ projectId, appId }) => {
  const { t } = useTranslation();
  const buildAppMessages = () => {
    if (appId == "google") {
      return {
        title: t("Allow Sales CRM to access Gmail."),
        link: (
          <Link
            to={`/workspaces/${projectId}/settings/apps?key=Apps&appId=google&item=Gmail`}
            className="inline-flex items-center gap-x-1.5 rounded-2xl bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            <EnvelopeIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            {t("Allow Gmail access")}
          </Link>
        ),
      };
    }
    return {
      title: t("Allow Sales CRM to access Outlook."),
      link: (
        <Link
          to={`/workspaces/${projectId}/settings/apps?key=Apps&appId=azure&item=Outlook`}
          className="inline-flex items-center gap-x-1.5 rounded-2xl bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          <EnvelopeIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
          {t("Allow Outlook access")}
        </Link>
      ),
    };
  };

  const { title, link } = buildAppMessages();
  return (
    <div className={"space-y-2 w-full text-center pt-4"}>
      <div>{title}</div>
      {link}
    </div>
  );
};

export default InboxEmptyState;
